import React, {useEffect, useRef, useState} from "react";
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {AppBar, Divider, IconButton} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import {useSelector} from "../../store";
import Button from "../../lib/appfuse-react/component/Button";
import Space from "../../lib/appfuse-react/component/Space";
import Typography from "@material-ui/core/Typography";
import SearchField from "../../component/SearchField";
import Expander from "../../lib/appfuse-react/component/Expander";
import Toolbar from "../../component/Toolbar";
import {selectTitle} from "../../reducer/app/appReducer";
import i18n from "../../lib/appfuse-react/core/i18n";
import {selectContentTypes} from "../../reducer/content/contentTypeReducer";
import env from "../../lib/appfuse-react/core/env";
import lang from "../../lib/appfuse-react/core/lang";
import Box from "../../lib/appfuse-react/component/Box";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import {useHistory, useRouteMatch} from "react-router-dom";
import Image from "../../lib/appfuse-react/component/Image";
import {ReactComponent as LatestNewsIcon} from "../../image/latest-news.svg";
import LatestNews from "../../applet/LatestNews";
import RouteButton from "../../component/RouteButton";
import organizationService from "../../service/organization/organizationService";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";
import DrawerMenu from "../../component/AppletMenu/DrawerMenu";
import {isEmptyRichText} from "../Desktop";

const initialContext = {
    workspace: undefined
}

const ExplorerContext = React.createContext(initialContext);

const useStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 100,
        backgroundColor: theme.brand.appbar?.backgroundColor,
        color: theme.brand.appbar?.color,
    },
}));

function Explorer(props) {
    const theme = useTheme();
    const router = useRouter();
    const history = useHistory();
    const backgroundImage = router.resolve(theme.brand.backgroundImage);
    const classes = useStyles({backgroundImage});
    const [keyword, setKeyword] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const title = useSelector(selectTitle);
    const { path } = useRouteMatch();
    const contentTypes = useSelector(selectContentTypes);
    const responsive = env.responsive;
    const getResponsive = useResponsive();
    const workspaceRef = useRef();
    const workspace = workspaceRef?.current;

    // 組織
    const [organization, setOrganization] = useState({});
    // 最新消息
    const latestNewsRef = useRef(null);
    const [latestNewsOpen, setLatestNewsOpen] = useState(false);
    const handleLatestNewsOpen = () => setLatestNewsOpen(true);
    const handleLatestNewsClose = () => setLatestNewsOpen(false);

    useEffect(() => {
        (async () => {
            let latestNews = organization?.latestNews;
            if(lang.isEmpty(organization)) {
                const organization = await organizationService.get();
                setOrganization(organization);
                latestNews = organization?.latestNews;
            }
            if((path==='/' || path==='/main') && latestNews && !isEmptyRichText(latestNews)) {
                setLatestNewsOpen(true);
            }
        })();
    }, [path]);

    const handleSearch = event => {
        const keyword = event.value;
        setKeyword(keyword);
    }

    window.document.title = i18n.translate(title);

    const settings = env.get('app');

    const stageInfo = env.appStage.toUpperCase() === 'PROD' ? null : env.appStage;
    const versionInfo = env.appVersion + `${stageInfo ? '@' + stageInfo: ''}`;

    const bigScreen = getResponsive.isLargeScreen() || getResponsive.isMediumScreen();


    const handleMenu = () => {
        setMenuOpen(!menuOpen);
    }
    return (
        <Box className="app-explorer" fullHeight fullWidth overflow="hidden" display="flex" flexDirection="column">
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Image value={theme.brand.logo} onClick={()=> history.push('/')} height={bigScreen?36:36} title={versionInfo}/>
                    <Space spacing={1} />
                    {bigScreen ? <Typography variant="h5" noWrap>
                        {i18n.translate(title)}
                        <Space spacing={1} />
                        {stageInfo ? <Typography variant="body2" display="inline">{versionInfo}</Typography> : null}
                    </Typography> : <Typography variant="h6" noWrap></Typography>}
                    <Box display={lang.isFalse(settings.search) ? 'none' : 'initial'}>
                        <SearchField label="Search" value={keyword} onChange={handleSearch} />
                    </Box>
                    <Box paddingX={2}>
                        <Button icon={<LatestNewsIcon/>} variant='text' text={bigScreen?"Latest News":""} color='inherit' ref={latestNewsRef} onClick={handleLatestNewsOpen}/>
                        {latestNewsOpen && <LatestNews open={latestNewsOpen} anchorEl={latestNewsRef} data={organization?.latestNews} onClose={handleLatestNewsClose}/>}
                    </Box>
                    <Expander />
                    {bigScreen ? <React.Fragment>
                        <RouteButton text="Course announcement" route='/courseAnnouncement' path={path}/>
                        <RouteButton text="Course Fee" route='/courseFee' path={path}/>
                        <RouteButton text="Course Brief" route='/courseBrief' path={path}/>
                        <RouteButton text="Contact Us" route='/contactUs' path={path}/>
                        <RouteButton text="Traffic Information" route='/trafficInfo' path={path}/>
                        <RouteButton text="Other Information" route='/otherInfo' path={path}/>
                        <Divider orientation='vertical' variant='middle' style={{backgroundColor: 'rgba(255, 255, 255, 0.7)', height: '50%'}}/>
                        <Button text="Login" variant="text" color="inherit" onClick={() => history.push('/logon')} />
                        <Box display={lang.isFalse(settings.registration) ? 'none' : 'initial'}>
                            <Button text="Register" variant="text" color="inherit" onClick={() => history.push('/registration')}/>
                        </Box>
                        <Button text="New Lecturer" variant="text" color="inherit" onClick={() => history.push('/newLecturer')} />
                    </React.Fragment> : <Box>
                        <IconButton color="inherit" onClick={handleMenu}>
                            <MenuIcon />
                        </IconButton>
                    </Box>}
                </Toolbar>
            </AppBar>
            <DrawerMenu open={menuOpen} onClose={handleMenu} onOpen={handleMenu} />
            <Box fullHeight fullWidth  overflow="auto" backgroundImage={backgroundImage}>
                <Box ref={workspaceRef} fullHeight fullWidth overflow="hidden"  minWidth={`${responsive.minWidth}px`}>
                    <ExplorerContext.Provider value={{workspace}}>
                        {props.children}
                    </ExplorerContext.Provider>
                </Box>
            </Box>
        </Box>
    )
}


const withExplorer = WrappedComponent => (props) => {
    return (
        <Explorer>
            <WrappedComponent {...props} />
        </Explorer>
    );
};

export default Explorer;

export { withExplorer, ExplorerContext };